import { FC } from 'react';
import { Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { useAppContext } from 'src/contexts/AppContext';
import { useAuthContext } from 'src/contexts/AuthContext';
import { dayjs } from 'src/libs/dayjs';

/**
 * Full-screen wall shown to authorized users whose customer's subscription
 * has ended (customers_list.subscription_until_due, inclusive end day). The
 * backend rejects all customer-scoped data requests for expired customers,
 * so there is no dashboard to show — only renewal guidance. Yapamar staff
 * are exempt and never see this page.
 */
export const SubscriptionExpired: FC = () => {
  const bg = useColorModeValue(
    'background.light.lowest',
    'background.dark.lowest',
  );
  const { currentCustomer } = useAppContext();
  const { signOut } = useAuthContext();

  const untilDue = currentCustomer?.subscriptionUntilDue;

  return (
    <Flex w="100%" h="100vh" direction="row" background={bg}>
      <Flex
        flex="1"
        h="100%"
        w="100%"
        direction="column"
        justifyContent="center"
        alignItems="center"
        px="40px"
        py="24px">
        <Flex direction="column" justifyContent="flex-start" maxW="560px">
          <Heading as="h1" size="lg" mb={4} fontFamily="marketingPage">
            Your subscription has expired
          </Heading>
          <Text as="p" fontSize="lg" mb={2} fontFamily="marketingPage">
            {untilDue
              ? `Your subscription ended on ${dayjs(untilDue).format('DD.MM.YYYY')}.`
              : 'Your subscription has ended.'}{' '}
            Access to the dashboard is paused until it is renewed — your data
            and models are kept safe in the meantime.
          </Text>
          <Text as="p" fontSize="lg" mb={6} fontFamily="marketingPage">
            Contact Yapamar to renew your plan and pick up right where you left
            off.
          </Text>
          <Button
            buttonName="subscription-expired-sign-out"
            onClick={signOut}
            alignSelf="flex-start"
            variant="outline"
            fontFamily="marketingPage">
            Sign out
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
